// extracted by mini-css-extract-plugin
module.exports = {"wrap":"List_wrap_t-7Fk","main":"List_main_k8kLv","side":"List_side_2G-V3","btn":"List_btn_t2i8i","list":"List_list_2Ax7F","img":"List_img_15U5v"};